module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAoCAMAAAAmLUHXAAAAQlBMVEUzMzP///8zMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzOnysCCAAAAFXRSTlMAAC00N0JOUltlab7h6+zx8vP2+v19P7ZHAAAAi0lEQVQoz33TQRaCMAwE0ESoIqgI2vtfVYp50kw6dvkXbZNMROCopsckQdOan0H7Jb/OAecNtYka8H1R0IKDgv5QEQX0i6CGXjtDp6e7Ya0HVlrhoRvmq4AWHAXUoymg6c3jX23f0H6N/IxUQSom3SGdJF0nEyLTJJMnKSGJIukjSSWpJhtAtmXfrA9FQgqlE6ju5AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/true.png
// module id = 156
// module chunks = 18